module.exports = __webpack_public_path__ + "img/slide-6.1bcf10ef.png";